import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import DialBackPage from "../pages/dial-back/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/dial-back",
    element: <DialBackPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
